import ValueAddedServices from "../../../jsx/components/Dashboard/VAS/valueaddedservices";

const ValueAddedServicesWrapper = () => {
  return <ValueAddedServices />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];

export default constore(ValueAddedServicesWrapper);
